import React from "react";
import { readPin } from "../devices/actions";
import { SensorListProps } from "./interfaces";
import { sortResourcesById } from "../util";
import { Row } from "../ui";
import { isNumber } from "lodash";
import { ALLOWED_PIN_MODES } from "farmbot";
import { t } from "../i18next_wrapper";

interface SensorReadingDisplayProps {
  label: string;
  value: number | undefined;
  mode: number;
}

interface CalcStyleProps {
  value: number;
  mode: number;
}

const calcIndicatorStyle = ({ value, mode }: CalcStyleProps) => {
  if (mode === 0) {
    // 数字传感器：0 或 1 二值显示
    return {
      width: value > 0 ? '100%' : '0%',
    };
  } else {
    // 模拟传感器：0-1023 范围值显示
    const percentage = Math.min(100, (value / 1023) * 100);
    return {
      width: `${percentage}%`,
    };
  }
};

const SensorReadingDisplay =
  ({ label, value, mode }: SensorReadingDisplayProps) => {
    const moistureSensor = label.toLowerCase().includes("moisture")
      ? "moisture-sensor"
      : "";
    const toolSensor = label.toLowerCase().includes("verification")
      ? "tool-verification-sensor"
      : "";

    // 数字传感器：值为1时添加 active 类
    const digitalActiveClass = mode === 0 && value > 0 ? "active" : "";

    const classNames = [
      "sensor-reading-display",
      moistureSensor,
      toolSensor,
      mode ? "analog" : "digital",
      digitalActiveClass,
    ];

    return <div className={classNames.join(" ")}>
      {isNumber(value) && value >= 0 &&
        <div className="indicator" style={calcIndicatorStyle({ value, mode })}>
          <span>{value}</span>
        </div>}
    </div>;
  };

export const SensorList = (props: SensorListProps) =>
  <div className="grid">
    {sortResourcesById(props.sensors).map(sensor => {
      const { label, mode, pin } = sensor.body;
      const pinNumber = (isNumber(pin) && isFinite(pin)) ? pin : -1;
      const value = (props.pins[pinNumber] || { value: undefined }).value;
      return <div key={sensor.uuid} className="sensor-row">
        <div className="sensor-info">
          <label className="sensor-name">{label}</label>
          <span className="sensor-pin">Pin {pinNumber}</span>
        </div>
        <div className="sensor-reading-section">
          <SensorReadingDisplay label={label} value={value} mode={mode} />
        </div>
        <ReadSensorButton
          disabled={!!props.disabled}
          sensorLabel={label}
          pinNumber={pinNumber}
          mode={mode} />
      </div>;
    })}
  </div>;

interface ReadSensorButtonProps {
  disabled: boolean;
  sensorLabel: string;
  pinNumber: number;
  mode: number;
}

const ReadSensorButton = (props: ReadSensorButtonProps) => {
  const { disabled, sensorLabel, pinNumber, mode } = props;
  return <button
    className={"fb-button gray"}
    disabled={disabled}
    title={t(`read ${sensorLabel} sensor`)}
    onClick={() => {
      readPin(pinNumber, `pin${pinNumber}`, mode as ALLOWED_PIN_MODES);
    }}>
    {t("read sensor")}
  </button>;
};
